import SelectField from './SelectField';
import RadioGroupField from './RadioGroupField';
import InputField from './InputField';
import NumberField from './NumberField';
import FileInputField from './FileInputField';
import DatePickerField from './DatePickerField';
import MultiSelectField from './MultiSelectField';
import CheckboxField from './CheckboxField';
import { withInfoBox } from '../loan_application/components/withInfoBox';

export const SelectFieldWithInfoBox = withInfoBox(SelectField);
export const InputFieldWithInfoBox = withInfoBox(InputField);
export const NumberFieldWithInfoBox = withInfoBox(NumberField);
export const FileInputFieldWithInfoBox = withInfoBox(FileInputField);
export const RadioGroupFieldWithInfoBox = withInfoBox(RadioGroupField);
export const DatePickerFieldWithInfoBox = withInfoBox(
  DatePickerField as any
) as typeof DatePickerField;
export const MultiSelectFieldWithInfoBox = withInfoBox(MultiSelectField);
export const CheckboxFieldWithInfoBox = withInfoBox(CheckboxField);
